/**
 * Contrato de configuração do core.
 * Cada app (Web/Mobile) resolve os valores do seu próprio mecanismo de env
 * (import.meta.env no Vite, react-native-config no RN) e injeta aqui.
 */
export type Environment = 'development' | 'homologation' | 'production';

export interface CoreConfig {
  apiBaseUrl: string;
  environment: Environment;
  /** Timeout padrão das requisições em ms. */
  requestTimeoutMs: number;
  /** Versão do client, enviada no header para rastreio/observabilidade. */
  clientVersion: string;
  /** Identificação da origem da chamada (auditoria — PRJ-067). */
  clientOrigin: ClientOrigin;
}

export type ClientOrigin = 'web' | 'mobile' | 'extension' | 'api';

export const DEFAULT_REQUEST_TIMEOUT_MS = 30_000;

export function createCoreConfig(input: Partial<CoreConfig> & { apiBaseUrl: string }): CoreConfig {
  return {
    environment: 'development',
    requestTimeoutMs: DEFAULT_REQUEST_TIMEOUT_MS,
    clientVersion: '0.0.0',
    clientOrigin: 'web',
    ...input,
  };
}
